import { takeEvery, takeLatest, fork, put, call, race, take } from 'redux-saga/effects'

import fileDownload from 'js-file-download'

import { map } from 'lodash'

import { api, utils, settings, ui, i18n } from 'parking-react-common'


//
//  ACTIONS

export const MASS_DOWNLOAD_REQUESTED = '@ api / MASS_DOWNLOAD_REQUESTED'

//
//  SAGA

export function* saga() {
    yield fork(api.saga)
    yield takeEvery(api.DOWNLOAD_REQUESTED, handleDownloadRequest)
    yield takeEvery(api.DOWNLOAD_FAILED, handleDownloadFailure)
    yield takeLatest(MASS_DOWNLOAD_REQUESTED, handleMassDownloadRequest)
}

function* handleDownloadRequest({ payload }) {
    const { url, filename, options } = payload

    const method = 'GET'
    const config = {
        responseType : 'blob',
        timeout      : settings.API_DOWNLOAD_REQUEST_TIMEOUT,
        headers      : {
            Accept: utils.mimeType(filename)
        }
    }

    const requestData = { method, url, ...config, ...options }

    try {
        const response = yield call(api.http.request, { method, url, ...config, ...options })
        fileDownload(response.data, filename, utils.mimeType(filename))
        yield put({ type: api.DOWNLOAD_SUCCEEDED, payload: { ...requestData, response } })
    }
    catch (exception) {
        if (api.isNetworkError(exception)) {
            const { response } = exception
            const error = api.parseErrors(exception)
            yield put({ type: api.DOWNLOAD_FAILED, payload: { ...requestData, response, error } })
        }
        else if (api.isTimeoutError(exception)) {
            const { response } = exception
            const error = exception
            yield put({ type: api.DOWNLOAD_FAILED, payload: { ...requestData, response, error } })
        }
        else {
            throw exception
        }
    }
}

function* handleDownloadFailure() {
    yield put(ui.showToast({
        message : i18n.t('Cannot download file.'),
        intent  : ui.INTENT.error
    }))
}

function* handleMassDownloadRequest({ payload }) {
    const { dataURL, data } = payload
    const ids = map(data, 'id')

    yield put(api.get(dataURL, { id: 'mass-download', ids }))

    const { success } = yield race({
        success : take(api.SUCCEEDED),
        failure : take(api.FAILED)
    })

    if (success) {
        yield put(ui.showToast({
            message : i18n.t('This will take some time. You will get a link in an email or sms.'),
            intent  : ui.INTENT.success
        }))
    }
    else {
        yield put(ui.showToast({
            message : i18n.t('Cannot download files.'),
            intent  : ui.INTENT.error
        }))
    }
}

export default {
    ...api,
    saga,

    MASS_DOWNLOAD_REQUESTED
}
